import React from "react";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import MissingMerchandiserChargesList from "./list-missing-merchandiser-charges";
import MissingClientChargesList from "./list-missing-client-charges";
// import ServiceInvoicesList from "./list-service-invoices";
// import ClientInvoicesList from "./list-client-export";

class MissingChargesList extends React.Component {
    tabs = {
        missingMerchandiserCharges: "missingMerchandiserCharges",
        missingClientCharges: "missingClientCharges"
    };

    render() {
        const {
            missingMerchandiserCharges,
            missingClientCharges,
            missingMerchandiserChargesLoading,
            missingClientChargesLoading
        } = this.props;

        const missingMerchandiserChargesCount =
            missingMerchandiserChargesLoading ? "" : ` - ${missingMerchandiserCharges.length} found`;
        const missingClientChargesCount =
            missingClientChargesLoading ? "" : ` - ${missingClientCharges.length} found`;

        return (
            <div>
                <h3 className="mb-4">
                    Missing Charges
                </h3>
                <Tabs
                    id="accounting-tabs"
                    defaultActiveKey={this.tabs.missingMerchandiserCharges}
                    className="w-100"
                    // unmountOnExit={true}
                >
                    <Tab
                        eventKey={this.tabs.missingMerchandiserCharges}
                        title={`Missing Merchandiser Charges${missingMerchandiserChargesCount}`}
                    >
                        <MissingMerchandiserChargesList/>
                    </Tab>
                    <Tab
                        eventKey={this.tabs.missingClientCharges}
                        title={`Missing Client Charges${missingClientChargesCount}`}
                    >
                        <MissingClientChargesList/>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    missingMerchandiserCharges: state.invoicing.missingMerchandiserCharges,
    missingClientCharges: state.invoicing.missingClientCharges,

    missingMerchandiserChargesLoading: state.invoicing.missingMerchandiserChargesLoading,
    missingClientChargesLoading: state.invoicing.missingClientChargesLoading,
});

export default connect(
    mapStateToProps
)(MissingChargesList);
